export const calendar = (state) => {
  return state.calendar.data || []
}
export const calendarLoading = (state) => {
  return state.calendar.loading
}
export const calendarLastUpdate = (state) => {
  return state.calendar.lastUpdate
}

export const clients = (state) => {
  return state.clients.data || []
}
export const clientsLoading = (state) => {
  return state.clients.loading
}
export const clientsLastUpdate = (state) => {
  return state.clients.lastUpdate
}
